

import React, { memo } from 'react';
import ButtonFactory from './ButtonFactory';


function SubmitButton({ children, ...props }) {
  return <button type="submit" {...props}>{children}</button>;
}

export default memo(ButtonFactory(SubmitButton));